function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.032 17.75c0 .69-.554 1.25-1.238 1.25-.683 0-1.238-.56-1.238-1.25s.555-1.25 1.238-1.25c.684 0 1.238.56 1.238 1.25zm-8.254 0c0 .69-.555 1.25-1.238 1.25-.684 0-1.238-.56-1.238-1.25s.554-1.25 1.238-1.25c.683 0 1.238.56 1.238 1.25zm6.093-4.583H9.583l-1.351-5h10.116l-2.476 5zm3.88-5.877a1.636 1.636 0 00-1.403-.79H7.782l-.51-1.886A.827.827 0 006.477 4h-1.65A.83.83 0 004 4.833c0 .46.369.834.825.834h1.02l2.311 8.552a.827.827 0 00.797.614h7.429a.825.825 0 00.738-.46l2.704-5.461a1.67 1.67 0 00-.072-1.622z",
  fill: "#fff"
});

function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgShop;